import {
  IClientCategoryAPIResponse,
  IClientCategoryResponse,
} from 'types/models/ClientCategory/ClientCategory';

export const transformClientCategoryResponse = (
  responseData: IClientCategoryAPIResponse,
): IClientCategoryResponse => {
  return {
    data: responseData.results.map((res) => {
      return {
        id: res.id,
        nameAr: res.nameAr,
        nameFr: res.nameFr,
        status: res.status,
        minimumOrderPrice: res?.minimumOrderPrice,
      };
    }),
    lastPage: responseData.lastPage,
    total: responseData.total,
    totalPerPage: responseData.totalPerPage,
    nextPage: responseData.nextPage,
    previousPage: responseData.previousPage,
    currentPage: 1,
  };
};
